import { getStore } from 'store';
import { get } from 'lodash';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc An utility function to do [something]
 * @example
 * import { getAppSyncData } from 'utils/getAppSyncData';
 * const result = getAppSyncData( ...args );
 */
export const getAppSyncData = ( name ) => {
    const syncData = get( store.getState()[ REDUCER.APP_CONTEXT ], 'component.data.state.syncData', {} );
    return get( syncData, `${name}`, undefined );
};
